import { routerReducer } from 'react-router-redux';
import StageStore from './StageStore';
import CrisisStore from './CrisisStore';
import UserLogStore from './UserLogStore';

module.exports = {
    stage: StageStore,
    crisis: CrisisStore,
    userLog: UserLogStore,
    routing: routerReducer,
};



// WEBPACK FOOTER //
// ./js/stores/index.js